import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert, TextField,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const EditarProductoDialog = ({ open, onClose, producto, onEditado }) => {
  const [form, setForm] = useState({ nombre: "", marca: "", detalle: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && producto) {
      setForm({ nombre: producto.nombre || "", marca: producto.marca || "", detalle: producto.detalle || "" });
      setError("");
    }
  }, [open, producto]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/inventario-interno/productos/${producto.id}`, {
        nombre: form.nombre.trim(),
        marca: form.marca.trim(),
        detalle: form.detalle.trim(),
      });
      onEditado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al editar el producto.");
    } finally {
      setSaving(false);
    }
  };

  const puedeGuardar = form.nombre.trim() && !saving;

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Editar producto</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            size="small" label="Nombre" required
            value={form.nombre} onChange={handleChange("nombre")}
          />
          <TextField
            size="small" label="Marca"
            value={form.marca} onChange={handleChange("marca")}
          />
          <TextField
            size="small" label="Detalle" multiline minRows={2}
            value={form.detalle} onChange={handleChange("detalle")}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar}>
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarProductoDialog;
